module.exports = __webpack_public_path__ + "img/622F19_885934_9A7748_94603A-256px.37699d4f.png";